import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import { Article } from './BlogGrid';

interface BlogCardProps {
  article: Article;
  currentLang?: 'sl' | 'en';
}

export default function BlogCard({ article, currentLang = 'sl' }: BlogCardProps) {
  return (
    <Link
      href={`/blog/${article.slug}`}
      className="group block card-rounded overflow-hidden bg-card border border-border hover:shadow-xl transition-all duration-300"
    >
      {/* Image */}
      <div className="relative h-64 overflow-hidden">
        <AppImage
          src={article.image}
          alt={article.alt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4">
          <span className="px-4 py-1 bg-primary text-primary-foreground text-xs font-bold uppercase tracking-wider rounded-full">
            {article.category}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-2xl font-bold tracking-tight mb-3 group-hover:text-primary transition-colors">
          {article.title}
        </h3>
        <p className="text-muted-foreground mb-4 line-clamp-2">{article.excerpt}</p>

        {/* Meta */}
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <span className="font-medium">{article.author}</span>
            <span>•</span>
            <span>{article.date}</span>
          </div>
          <span className="font-medium">{article.readTime}</span>
        </div>
      </div>
    </Link>
  );
}